import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import { ReportTable } from '@/components/report-tables'
import { actionCreators } from '@/store/ReportTemplate'
import LoadingIndicator from '@/components/LoadingIndicator'
import context from '@/context'
import { downloadFile } from '@/utils/downloader'
import Resx from '@/components/Resx'
import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import { DownloadVersionDefinitions } from '@/internal-app/pages/administration/report-templates/downloadVersionDefinitions'
import { useDispatch } from '@/hooks/dispatch'
import { useLocalization } from '@/hooks/localization'

const ReportTemplateVersionDetail = React.memo((props) => {
  const [getReportTemplateDetail] = useDispatch([actionCreators.getReportTemplateDetail])
  const reportDetail = useSelector(state => state.reportTemplate.reportDetail)
  const { localizeValue } = useLocalization()

  const id = props.match.params.id
  const parentId = props.match.params.parentId
  const [generating, setGenerating] = useState(false)
  const [xlsxOpen, setXlsxOpen] = useState(false)

  useEffect(() => getReportTemplateDetail(id), [getReportTemplateDetail, id])

  const onDownloadFileClick = useCallback((english) => {
    setGenerating(true)
    downloadFile({ Id: id, EnglishTranslation: english }, context.api.reportExportService.exportReportTemplateAsExcelFile, () => setGenerating(false))
  }, [id])

  const onDownloadEnExport = useCallback(() => {
    onDownloadFileClick(true)
  }, [onDownloadFileClick])

  const onDownloadArExport = useCallback(() => {
    onDownloadFileClick(false)
  }, [onDownloadFileClick])

  const toggleXlsxOpen = useCallback(() => {
    setXlsxOpen(!xlsxOpen)
  }, [setXlsxOpen, xlsxOpen])

  return <React.Fragment>
    <Main>
      <MainTop>
        <MainTopTitle backUrl={`/administration-report-templates/${parentId}`}>
          {reportDetail
            ? localizeValue(`${reportDetail.category}-${reportDetail.name}`, `${reportDetail.latinCategory}-${reportDetail.latinName}`)
            : ''}
        </MainTopTitle>
      </MainTop>
      <MainBody>
        <ButtonDropdown disabled={generating} isOpen={!generating && xlsxOpen} toggle={toggleXlsxOpen}
          style={{ marginRight: '2px' }}>
          <DropdownToggle caret>
            <Resx name={'Reporting.DownloadAsXlsx'} />
          </DropdownToggle>
          <DropdownMenu>
            <Resx render={(locale) =>
              <React.Fragment>
                <DropdownItem onClick={onDownloadEnExport}>{locale.localize('Reporting.InEnglishLanguage')}</DropdownItem>
                <DropdownItem onClick={onDownloadArExport}>{locale.localize('Reporting.InArabicLanguage')}</DropdownItem>
              </React.Fragment>
            } />
          </DropdownMenu>
        </ButtonDropdown>
        {reportDetail && <DownloadVersionDefinitions templateVersionId={id} />}
        {!reportDetail && <LoadingIndicator />}
        {reportDetail && <Resx render={(localize) =>
          <ReportTable
            persistenceId={reportDetail.code}
            isRtl={localize.rtl}
            sourceHeaders={reportDetail.allCols}
            sourceRowHeaders={reportDetail.allRows}
            defaultMetadata={{ readOnly: true }}
            renderAllRows
            readOnly
          />}
        />}
      </MainBody>
    </Main>
  </React.Fragment>
})

ReportTemplateVersionDetail.propTypes = {
  match: PropTypes.object,
  getReportTemplateDetail: PropTypes.func,
  reportDetail: PropTypes.object
}

export { ReportTemplateVersionDetail }



// WEBPACK FOOTER //
// ./src/internal-app/pages/reporting/reportTemplateDetail.js